import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=807ca370"
import script from "./Clients.vue?vue&type=script&lang=ts"
export * from "./Clients.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports